import { mastersActions } from "../slices/MasterSlice";
import { AppDispatch } from "..";
import { fetchAllMasters } from "../../services/masters";

export const getAllMasters = () => {
  return async (dispatch: AppDispatch) => {
    try {
      const mastersRes = await fetchAllMasters();

      if (mastersRes.status === 200) {
        dispatch(mastersActions.fetchAllMaster(mastersRes.data));
      }
    } catch (error) {
      console.log(error);
    }
  };
};
